import { Button, Divider, MenuItem, TableCell, TableRow } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import ShortButton from 'components/atoms/button/ShortButton'
import RowStack from 'components/atoms/container/RowStack'
import SearchInputBox from 'components/atoms/input/SearchInputBox'
import { StyledSelect } from 'components/atoms/input/StyledInputs'
import DateCell from 'components/atoms/table/DateCell'
import PresetTableContainer from 'components/atoms/table/PresetTableContainer'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import { DownloadTableExcel } from 'react-export-table-to-excel'

const OrganizationsTable = ({
  companyList,
  setSelectedCompany,
  otherActions
}) => {
  const tableRef = useRef(null)
  const [currentTableRef, setCurrentTableRef] = useState(undefined)
  const [nameFilter, setNameFilter] = useState('')
  const [licenseFilter, setLicenseFilter] = useState('')
  const [licenseStatusFilter, setLicenseStatusFilter] = useState('Active')
  const [filteredList, setFilteredList] = useState(companyList)
  const [expiryDateStart, setExpiryDateStart] = useState(null)
  const [expiryDateEnd, setExpiryDateEnd] = useState(null)

  useEffect(() => {
    setCurrentTableRef(tableRef.current)
  }, [companyList])

  useEffect(() => {
    let newCompanyList = [...companyList]
    if (nameFilter.length > 0) {
      newCompanyList = newCompanyList.filter(c =>
        c.name.toLowerCase().includes(nameFilter.toLowerCase())
      )
    }
    if (licenseStatusFilter) {
      newCompanyList = newCompanyList.filter(
        c => licenseStatus(c) === licenseStatusFilter
      )
    }
    if (licenseFilter?.length > 0) {
      newCompanyList = newCompanyList.filter(
        c => c.licenseType === licenseFilter
      )
    }
    if (expiryDateStart) {
      newCompanyList = newCompanyList.filter(c =>
        moment.utc(c.licenseExpireAt).isAfter(expiryDateStart)
      )
    }
    if (expiryDateEnd) {
      newCompanyList = newCompanyList.filter(c =>
        moment.utc(c.licenseExpireAt).isBefore(expiryDateEnd)
      )
    }
    setFilteredList(newCompanyList)
  }, [
    nameFilter,
    licenseStatusFilter,
    companyList,
    licenseFilter,
    expiryDateStart,
    expiryDateEnd
  ])
  const licenseStatus = c =>
    moment.utc(c.licenseExpireAt).isAfter() && c.licenseCount > 0
      ? 'Active'
      : c.licenseCount > 0
        ? 'Expired'
        : '-'
  return (
    <>
      <RowStack justifyContent='space-between'>
        <RowStack spacing={3}>
          {otherActions}
          <SearchInputBox
            style={{ padding: 0 }}
            placeholder='Search by Org Name'
            onChangeHandler={e => setNameFilter(e.target.value)}
          />
          <StyledSelect
            sx={{ minWidth: 200 }}
            displayEmpty
            placeholder='by License Type'
            name='licenseType'
            value={licenseFilter}
            onChange={e => setLicenseFilter(e.target.value)}>
            <MenuItem value=''>All License Type</MenuItem>
            <MenuItem value='invoice'>Invoice</MenuItem>
            <MenuItem value='trial'>Trial</MenuItem>
          </StyledSelect>
          <StyledSelect
            sx={{ minWidth: 200 }}
            displayEmpty
            placeholder='by License Status'
            name='licenseStaus'
            value={licenseStatusFilter}
            onChange={e => setLicenseStatusFilter(e.target.value)}>
            <MenuItem value=''>All License Status</MenuItem>
            <MenuItem value='Active'>Active</MenuItem>
            <MenuItem value='Expired'>Expired</MenuItem>
            <MenuItem value='-'>Others</MenuItem>
          </StyledSelect>

          <DatePicker
            label='Expiry Date Start'
            value={expiryDateStart}
            onChange={date => setExpiryDateStart(date)}
            slotProps={{
              actionBar: {
                actions: ['clear']
              }
            }}
          />
          <DatePicker
            label='Expiry Date End'
            value={expiryDateEnd}
            onChange={date => setExpiryDateEnd(date)}
            slotProps={{
              actionBar: {
                actions: ['clear']
              }
            }}
          />
        </RowStack>
        {currentTableRef && (
          <DownloadTableExcel
            filename={`organization-licenses`}
            sheet='sheet1'
            currentTableRef={currentTableRef}>
            <Button>Export</Button>
          </DownloadTableExcel>
        )}
      </RowStack>
      <Divider width='100%' />
      <PresetTableContainer
        tableProps={{ ref: tableRef }}
        maxHeight='inherit'
        headers={
          <>
            <TableCell sx={{ width: 200 }}>Company Name</TableCell>
            <TableCell sx={{ width: 150 }}>Domain</TableCell>
            <TableCell>License Type</TableCell>
            <TableCell>License Expires At</TableCell>
            <TableCell>License Count</TableCell>
            <TableCell>License Status</TableCell>
            <TableCell>Last Updated</TableCell>
            <TableCell sx={{ width: 100 }}>Active Licensed User #</TableCell>
            <TableCell sx={{ width: 80 }}>Rater Only #</TableCell>
            <TableCell>Actions</TableCell>
          </>
        }>
        {filteredList.map(c => (
          <TableRow key={c.id}>
            <TableCell>{c.name}</TableCell>
            <TableCell>{c.domains?.join(' | ')}</TableCell>
            <TableCell>{c.licenseType}</TableCell>
            <DateCell value={c.licenseExpireAt} includeTime />
            <TableCell>{c.licenseCount}</TableCell>
            <TableCell>{licenseStatus(c)}</TableCell>
            <DateCell value={c.updatedAt} includeTime />
            <TableCell>{c.licenseUserCount}</TableCell>
            <TableCell>{c.raterOnlyUserCount}</TableCell>
            <TableCell>
              <RowStack>
                <ShortButton data-testid={`manage-btn-${c.id}`} onClick={() => setSelectedCompany(c)}>
                  Manage
                </ShortButton>
              </RowStack>
            </TableCell>
          </TableRow>
        ))}
      </PresetTableContainer>
    </>
  )
}

export default OrganizationsTable
